import { Form, useFormState } from 'formular'


const useEditableMap = (form: Form<EditableMap.MapForm>) => {
  const { values } = useFormState(form)
  const { placemarks: placemarksField, polylines: polylinesField, multiPolygons: multiPolygonsField } = form.fields
  const { placemarks = [], polylines = [], multiPolygons = [] } = values

  return {
    placemarks,
    placemarksField,
    polylines,
    polylinesField,
    multiPolygons,
    multiPolygonsField,
  }
}

export default useEditableMap